import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { loadSearchMeta } from "../global-search/api";

export function useSelectionCapabilities() {
  const [state, setState] = useState({ loading: true, enabled: false, error: "" });

  useEffect(() => {
    const controller = new AbortController();
    loadSearchMeta(controller.signal)
      .then((payload) => setState({
        loading: false,
        enabled: Boolean(payload?.features?.selections),
        error: "",
      }))
      .catch((error) => {
        if (controller.signal.aborted || error?.name === "AbortError") return;
        setState({ loading: false, enabled: false, error: error.message });
      });
    return () => controller.abort();
  }, []);

  return state;
}

export default function SelectionFeatureGate({ children }) {
  useSourceLanguage();
  const state = useSelectionCapabilities();
  if (state.loading) {
    return <main className="selection-page"><p role="status"><LocalizedText source={"Vérification de Mes sélections…"} /></p></main>;
  }
  if (state.error) {
    return <main className="selection-page"><p role="alert">{state.error}</p></main>;
  }
  if (!state.enabled) return <Navigate to="/mes-eternua" replace />;
  return children;
}
